import { render } from "./OptionDropDown.vue?vue&type=template&id=2848f96e&scoped=true"
import script from "./OptionDropDown.vue?vue&type=script&lang=js"
export * from "./OptionDropDown.vue?vue&type=script&lang=js"

import "./OptionDropDown.vue?vue&type=style&index=0&id=2848f96e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2848f96e"]])

export default __exports__